<template>
  <div>
    <div class="demo-tab-panel">
      <div class="demo-title">Loading</div>
      <div class="demo-content">
        <div class="bx-btn bx-btn--sm" @click="showLoading()">Loading Show</div>
        <div class="bx-btn bx-btn--sm" @click="hideLoading()">Loading Hide</div>
      </div>
    </div>
    <div class="demo-tab-panel">
      <div class="demo-title">Loading To Success By Canvas</div>
      <div class="demo-content">
        <div class="loading-success" style="width: 100px;height: 100px;margin:15px auto"></div>
        <div class="bx-btn bx-btn--sm" @click="loadingReset()">Reset Loading</div>
        <div class="bx-btn bx-btn--sm" @click="loadingPause()">Pause Loading</div>
        <div class="bx-btn bx-btn--sm" @click="loadingToSuccess()">Loading To Success</div>
      </div>
    </div>
    <div class="demo-tab-panel">
      <div class="demo-title">Loading To Success By SVG</div>
      <div class="demo-content">
        <svg class="loading-success-svg" xmlns="http://www.w3.org/2000/svg" version="1.1">
          <circle class="loading-success-circle" cx="40" cy="40" r="30"></circle>
          <polyline class="loading-success-line" points="20,40 35,55 60 30"></polyline>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
  import Loading from '@packages/components/loading/loading'
  export default {
    data () {
      return {
        stroke: [],
        loading: null
      }
    },
    methods: {
      showLoading: function () {
        Loading.show({
          canvas: true
        });
      },
      hideLoading: function () {
        Loading.hide();
      },
      loadingToSuccess: function () {
        this.loading.success();
      },
      loadingReset: function () {
        this.loading.start();
      },
      loadingPause: function () {
        this.loading.stop();
      }
    },
    mounted: function () {
      var self = this;
      this.$nextTick(function () {
        self.loading = Loading.success('.loading-success', {
          onSuccess: function () {
            console.log('success');
          }
        });
        self.loading.start();
      });
    }
  }
</script>
<style>
  body {
    background-color: #FFF !important;
  }
</style>
<style scoped>

  .loading-success-svg {
    width: 80px;
    height: 80px;
  }

  .loading-success-circle {
    stroke: #000;
    fill: none;
    stroke-width: 3;
    transform-origin: 50% 50%;
    stroke-linecap: round;
    animation: circle 1.5s;
    transform: rotate(-45deg);
  }

  .loading-success-line {
    fill: none;
    stroke: #000000;
    stroke-width: 4;
    stroke-linecap: round;
    animation: line 3s;
  }

  @keyframes circle {
    0% {
      transform: rotate(-45deg);
      stroke-dasharray: 30 300;
    }
    75% {
      transform: rotate(675deg);
      stroke-dasharray: 30 300;
    }
    100% {
      transform: rotate(675deg);
      stroke-dasharray: 300 0;
    }
  }

  @keyframes line {
    0% {
      stroke-width: 0;
      stroke-dasharray: 0 300;
    }
    50% {
      stroke-width: 0;
      stroke-dasharray: 0 300;
    }
    51% {
      stroke-width: 4;
      stroke-dasharray: 0 300;
    }
    100% {
      stroke-width: 4;
      stroke-dasharray: 300 50;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Loading.vue